var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 3.25C10.0963 3.25 8.33375 3.85822 6.89744 4.89081C6.67323 5.052 6.62214 5.36444 6.78333 5.58865C6.94452 5.81286 7.25695 5.86395 7.48117 5.70276C8.75305 4.78838 10.3127 4.25 11.9995 4.25C16.2795 4.25 19.749 7.71958 19.749 11.9995C19.749 16.2795 16.2795 19.749 11.9995 19.749C7.71958 19.749 4.25 16.2795 4.25 11.9995C4.25 10.7828 4.53007 9.63282 5.02879 8.60939C5.27072 8.11293 5.5642 7.64603 5.90236 7.21568C6.07297 6.99855 6.03526 6.68422 5.81813 6.51361C5.601 6.343 5.28667 6.38071 5.11606 6.59784C4.7345 7.08343 4.40313 7.61053 4.12984 8.17133C3.56608 9.32824 3.25 10.6277 3.25 11.9995C3.25 16.8318 7.1673 20.749 11.9995 20.749C16.8318 20.749 20.749 16.8318 20.749 11.9995C20.749 7.1673 16.8318 3.25 11.9995 3.25ZM12.4995 7.87518C12.4995 7.59903 12.2756 7.37518 11.9995 7.37518C11.7233 7.37518 11.4995 7.59903 11.4995 7.87518V12.5155C11.4995 12.7155 11.6186 12.8963 11.8025 12.9751L15.4117 14.5219C15.6655 14.6307 15.9594 14.5131 16.0682 14.2593C16.177 14.0055 16.0594 13.7115 15.8056 13.6027L12.4995 12.1858V7.87518Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.cef6a96bac9180ec480fca411055e59d.svg";
export { ForwardRef as ReactComponent };